import { CodeListType } from '../../pages/ProgressNote/ProgressNote';
import { ApiResponseHandler } from '../ApiResponseHandler';
import ThomApiClient from '../ThomApiClient';

export const GetServiceAndSettingsCode = async (): Promise<CodeListType> => {
  return ApiResponseHandler(await ThomApiClient.getInstance().get(`codes`));
};
